module.exports = __webpack_public_path__ + "static/media/girl_cutting_grass.9222f9f0.png";